import { render, staticRenderFns } from "./line.vue?vue&type=template&id=4828460a&scoped=true&"
import script from "./line.vue?vue&type=script&lang=js&"
export * from "./line.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4828460a",
  null
  
)

export default component.exports